import { render, staticRenderFns } from "./ChooseFoldScreen.vue?vue&type=template&id=92bf8f0a&scoped=true"
import script from "./ChooseFoldScreen.vue?vue&type=script&lang=js"
export * from "./ChooseFoldScreen.vue?vue&type=script&lang=js"
import style0 from "./ChooseFoldScreen.vue?vue&type=style&index=0&id=92bf8f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bf8f0a",
  null
  
)

export default component.exports